import styled from '@emotion/styled';

export const Title = styled.h1`
    font-size: 3rem;
    color: white;
`;
